import { Icon } from '@iconify/react';

import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import LogoutIcon from '@mui/icons-material/Logout';

// ----------------------------------------------------------------------

const getIcon = (name) => <Icon icon={name} width={22} height={22} />;

const sidebarConfig = [
  {
    title: 'nav_video',
    path: '/my/video',
    icon: <VideoLibraryIcon></VideoLibraryIcon> //getIcon(pieChart2Fill)
  },
  {
    title: 'nav_logout',
    path: '/logout',
    icon: <LogoutIcon></LogoutIcon>
  }
];

export default sidebarConfig;
